import React from "react";
import DynamicComponent from "./DynamicComponent";
import SbEditable from "storyblok-react";
import Seo from "../utils/seo";

const Page = ({ blok, page }) => {
  const content =
    blok.body &&
    blok.body.map((childBlok) => (
      <DynamicComponent blok={childBlok} key={childBlok._uid} page={page} />
    ));
  
  const shouldGradientBg = blok?.gradient_background;

  return (
    <div className="bg-white"
      style={
        shouldGradientBg
          ? {
              background: 'linear-gradient(180deg, #01947c 0%, #01908e 15%, #002432 30%)',
              backgroundAttachment: 'scroll',
              marginTop: '-100px',
              minHeight: '100vh',
              paddingTop: '100px',
              width: '100%',
            }
          : {}
    }>
      <SbEditable content={blok} key={blok._uid}>
        <Seo
          title={blok.meta?.title}
          description={blok.meta?.description}
          canonical={blok.canonical_override?.cached_url}
          noindex={blok?.no_index ? 'noindex' : undefined}
          nofollow={blok?.no_follow ? 'nofollow' : undefined}
        />
        
        {content}
      </SbEditable>
    </div>
  );
};

export default Page;
